import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link'

import cName from 'classnames';
import styles from './index.module.scss';

import Wrapper from '@/components/wrapper';

import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';

import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_medium_list`)
  return {
    props: {
      ...res.props,
      data: data?.data || null,
    }
  }
}

const Partner: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("media.partner");

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <div className={styles.imgList}>
            <ul>
              {
                data?.map((child: any) => (
                  <li key={child.id}>
                    <Link href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                      <a>
                        <img src={child.image} alt={child[`title_${router.locale}`]} />
                      </a>
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
          <p>{t('hint')}</p>
        </div>
      </Wrapper >
    </div >
  );
};

export default Partner;
